<template>
  <div class="app-content">
    <div v-if="isShowNavBar" class="nav-header van-hairline--bottom">
      <van-nav-bar
          :title="title"
          :left-text="isShowNavLeft ? '返回' : ''"
          :border="false"
          :left-arrow="isShowNavLeft"
          :fixed="false"
          @click-left="onClickLeft">
<!--        自定义左侧区域内容 -->
        <template v-if="isShowNavLeft" #left>
          <slot name="nav-left"></slot>
        </template>
<!--        自定义标题 -->
        <template #title>
          <slot name="nav-title"></slot>
        </template>
<!--        	自定义右侧区域内容 -->
        <template #right>
          <slot name="nav-right"></slot>
        </template>
      </van-nav-bar>
      <slot name="nav-bottom"></slot>
    </div>
<!--    页面内容,固定高度,超出时显示滚动条-->
    <div class="main-content">
     <slot></slot>
    </div>
<!--   固定在页面底部 -->
    <div v-if="$slots.footer" class="app-footer">
      <slot name="footer"></slot>
    </div>
<!--    <van-overlay :show="isLoading" >-->
<!--      <van-loading/>-->
<!--    </van-overlay>-->
    <van-overlay :show="isLoading">
      <div class="center">
        <van-loading color="#ffffff" size="24px" vertical>加载中...</van-loading>
      </div>
    </van-overlay>
<!--    -->
<!--    <loading :is-loading="isLoading"></loading>-->
  </div>
</template>

<script>
  export default {
    name: "nav-page-view",
    props:{
      title:{
        type: String,
        default: ()=>{return ''}
      },
      isShowNavBar: {
        type: Boolean,
        default: true
      },
      isShowNavLeft: {
        type: Boolean,
        default: true
      },
      isLoading: {
        type: Boolean,
        default: false
      }
    },
    data(){
      return {

      }
    },
    created() {
    },
    methods: {
      onClickLeft() {
        if(this.isShowNavLeft){

          if(this.$slots['nav-left'] || this.$listeners['click-left']){
            this.$emit('click-left');
          }else {
            console.log("======>",window.history.length);
            if(window.history.length>2){
                this.$router.go(-1);
            }else{
                this.$router.push("/")
            }

          }
        }
      },
    }
  }
</script>

<style scoped lang="less">
  #app{
    .app-content{
      //height: 100%;
      height: 100vh;
      background-color: #f7f8fa;
      display: flex;
      flex-direction: column;
      >.nav-header{
        flex-shrink: 0;
        .van-nav-bar{
          /*margin: 0 auto;*/
          /*align-items: center;*/
          /*height: 46px;*/
          /*line-height: 46px;*/
          /*text-align: center;*/
          /*background-color: #409EFF;*/
          /*color: #fff;*/
          /*font-weight: 500;*/
          /*font-size: 16px;*/
        }
      }
      >.van-hairline--bottom:after{
        z-index: 1;
      }
      >.main-content{
        flex: 1;
        overflow: scroll;
        box-sizing: border-box;
      }
      >.app-footer{
        flex-shrink: 0;
        box-sizing: border-box;
      }
      .center {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
        .van-loading__text{
          color: #ffffff;
        }
      }
    }
  }
</style>